
/**
 * 
 */


document.addEventListener('DOMContentLoaded', function() {

	var isStorage = !!sessionStorage;
	if(isStorage) {

		var isStr = StorageOperator.isNotStorageData('session', 'state' );
		if( isStr ) {

			var state = StorageOperator.getStorageData('session', 'state');

			var poolObj = {};

			if(state.poolCateg) {

				var categ = state.poolCateg;
				if(categ==='Normal') {
					poolObj.array = state.or34===3 ? allDataObj.pool3: allDataObj.pool4;
				}else {
					poolObj.array = state.or34===3 ? allDataObj.highPool3: allDataObj.highPool4;
				};

			}else {
				poolObj.array = state.or34===3 ? allDataObj.pool3: allDataObj.pool4;
			};

			init(poolObj);
		}else {

			var isStrLo = StorageOperator.isNotStorageData('local', 'state');
			var or34 = isStrLo ? Number(StorageOperator.getStorageData('local', 'state')['or34']): 3;
			var boo = setOr34State(or34);

			var poolObj = {};
			poolObj.array = allDataObj.pool3;

			init(poolObj)
		};

	}else {
		alert('お使いのブラウザでは、本サイトは正常に動作しません');
	};

}, false);





function setOr34State(val) {

    var stateObj = StorageOperator.makePageStateJson( val );

    var boo = [false, false];
    try {
        boo = StorageOperator.setStorageData( 'session', 'state', stateObj );		
    }catch(exeption) {
        //alert('お使いのブラウザでは、本サイトは正常に動作しません');
    };
    return boo[0];
};


/*
var initCount = 0;
var dataObj = {};
	
function initFirst( namae, obj ) {
	General_init.init();
    initTherd( obj );
};

function initSecond(name, obj) {
	initCount++;

	if(name==='nb_pool') {  dataObj = obj;  };
	if(initCount===2) {
		General_init.init();
        initTherd( dataObj );
	};
};
*/


var customPersView;

function init( poolObj ) {
	General_init.init();
	initTherd( poolObj );
};
function initTherd( poolObj ) {
    
	customPersView = new CustomPerspectiveView( poolObj );

	document.getElementById('ifra-result').src = './NumbResultNC.html';
	
	var or34 =  Number(StorageOperator.getStorageData('session', 'state')['or34']);
	if(or34===3) {
		document.getElementById('nb3Img').style['display'] = 'block';
	}else {
		document.getElementById('nb4Img').style['display'] = 'block';
	};

	//  topSub
	document.getElementById('topSub-div').addEventListener('mouseenter', function() { return topSubFocus( topSubFocusSub )}, false);

};

function topSubFocus(sub) {
	let timer = window.setTimeout(function() {
		document.getElementById("topSub-inn-div").style['display'] = 'none';
		document.getElementById("soukannzu-div").style['display'] = 'block';
	},300);
	document.getElementById('topSub-div').removeEventListener('mouseleave',() => sub(), false);
	document.getElementById('topSub-div').addEventListener('mouseleave',() => sub(timer), false);
};
function topSubFocusSub(timer) {
	if(timer) {   window.clearTimeout(timer);   };
	document.getElementById("topSub-inn-div").style['display'] = 'block';
	document.getElementById("soukannzu-div").style['display'] = 'none';
};





class CustomPerspectiveView {

    constructor( poolObj ) {

        this._state = StorageOperator.getStorageData('session', 'state');
		this._or34 = this._state.or34;

		//let resultData = StorageOperator.getStorageData('session', 'nb_result');
		//this._resultDataArr = resultData.array;

		this._resultDataArr = allDataObj.result;

		let pool = poolObj;
		let poolArr = pool.array;
		

		this._dataHangar = new DataHangar( this._resultDataArr, this._or34 );
		this._contPool = new ContentsPool( this._dataHangar, poolArr );

		//

        let userCu = null;

        this._userCOp = new UserCustomOperator( this._or34, this._dataHangar.nb );
        
		this._userCOp.setUserCustomStateObj( userCu );
		let userCuList = this._userCOp.getUserCustomList();

		this._contPool.setUserCustomList( userCuList );
        
        this._setAllBtStyle();
        

		let dataLast = this._resultDataArr[ this._resultDataArr.length-1 ];
		let num = dataLast.nu;
		document.getElementById('yosouNum').textContent = `- ナンバーズ  ${this._or34} -`;


		this._allEventAdd();

		this._category_str_arr = [   'jik','jyo','fuk','cho','rea'   ];
		this._now_categ = this._category_str_arr[0];
		this._categ_text_arr = [   '軸数','除外','複待','重複','レア'   ];
		

		this._viewBooArray = [];


		/*  selectview  */

		this._SELECTBT_COLOR0 = { numb: 0,  back: [ 'rgb(25,90,245)', 'rgb(92,168,239)' ],  text: [  '#ffffff', '#eeeeff'  ]   };
		this._SELECTBT_COLOR1 = { numb: 1,  back: [ 'black', 'rgb(50,50,50)' ],  text: [  '#ffffff', '#eeeeff'  ]   };
		this._SELECTBT_COLOR2 = { numb: 2,  back: [ '#8888aa', 'rgb(230, 230, 245)' ],  text: [  '#111111', '#111133'  ]   };

		this._selectBtColorArray = [   this._SELECTBT_COLOR0, this._SELECTBT_COLOR1, this._SELECTBT_COLOR2   ];


		//  テーマ
		this._SELECTBT_COLOR = this._state.theme ?
								this._selectBtColorArray[this._state.theme] : this._selectBtColorArray[0];
		this._setColor();

		this._canvasViewObj = new CanvasView( this._SELECTBT_COLOR.numb );

		this.allEventAddSelectView();
		//
		/**  selectView end */

		/** canvasView */

		this._canvasViewObj.setPup3ObjDataDeploy(this.makeCanvasViewUseObj());
		this._canvasViewObj.paintAll();

		/** canvasView end */

		this.user_c_TableView();


		this._categBtColorArray = [ '#44469c','#5557ac','#6668bd','#7779cd','#888adf' ];
		this._categBtColorIndex = 0;

    };


    _allEventAdd() {

		for(let i=0; i<10; i++) {
			MyUtility.setElementEvent( 'btS'+i, 'click', () => this.funcPushS(i), false );
		};
		for(let i=0; i<10; i++) {
			MyUtility.setElementEvent( 'btJ'+i, 'click', () => this.funcPushJ(i), false );
		};

		for(let i=0; i<10; i++) {
			MyUtility.setElementEvent( 'btF'+i, 'click', () => this.funcPushF(i), false );
		};


		for(let i=0; i<2; i++) {
			MyUtility.setElementEvent( 'btC'+i, 'click', () => this.funcPushC(i), false );
		};

		MyUtility.setElementEvent( 'btR0', 'click', () => this.funcPushR(0), false );

		//  リセット
		for(let i=0; i<4; i++) {
			MyUtility.setElementEvent( 'chRt'+i, 'click', () => this.checkBoxRt(i), false );
		};

		MyUtility.setElementEvent( 'categBt', 'click', () => this.categoryChange(), false );

		MyUtility.setElementEvent( 'haneiBt', 'click', () => this.userCStrageSave(), false );


		if ("ontouchstart" in window) {
			MyUtility.setElementEvent('navData-down', 'click', MyUtility.buttonDownProcess( 'nav-pull-ul', false), false);
		}else {
	
			MyUtility.focusDownProcess( 'navData-down-li', 'nav-pull-ul' );
		};


		let helpNodes = document.getElementsByClassName('insertHelp');
		MyUtility.setElementEvent( 'help-show-bt', 'click', MyUtility.buttonDownProcessNodeArray( helpNodes, true), false );
		let textArray = [ '説明 ON', '説明 OFF' ];
		MyUtility.setElementEvent('help-show-bt', 'click', MyUtility.buttonTextChenge( 'help-show-bt', textArray), false);

	};
	

	/** selectView */
	allEventAddSelectView() {
		MyUtility.setElementEvent( 'opre_view', 'click', () => this.viewRangeChange(), false );
		MyUtility.setElementEvent( 'bt-theme', 'click', () => this.themeChange(), false );
	};

	_setColor() {

		this._setCenterLiColor();
	};

	_setCenterLiColor() {
		for(let i=0; i<3; i++) {
			MyUtility.setElementStyle( 'centerLi_'+i, 'backgroundColor', this._SELECTBT_COLOR.back[1] );
			MyUtility.setElementStyle( 'centerLi_'+i, 'border-color', this._SELECTBT_COLOR.text[1] );
		};

		MyUtility.setElementStyle( 'bt-theme', 'backgroundColor', this._SELECTBT_COLOR.back[1] );
		MyUtility.setElementStyle( 'bt-theme', 'border-color', this._SELECTBT_COLOR.text[1] );
		MyUtility.setElementStyle( 'bt-theme', 'color', this._SELECTBT_COLOR.text[1] );
	};

	//  テーマ変更
	themeChange() {

		for(let i=0, n=this._selectBtColorArray.length; i<n; i++) {
			if( this._SELECTBT_COLOR.numb === i ) {
				this._SELECTBT_COLOR = this._selectBtColorArray[(i+1)%n];
				break;
			};
		};
	
		this._setColor();
	
		this._canvasViewObj.themeChange();
	
		let boo = [true, true];
		try {
			boo = StorageOperator.storageSetProperty( 'theme', this._SELECTBT_COLOR.numb );
		}catch(exeption) {
			alert('お使いのブラウザでは、本サイトは正常に動作しません');
		};
	
	};
	
	

	viewRangeChange() {
	
		this._canvasViewObj.canvasViewRangeChange();
	};

	/** select view end */


	/** Contents Pool */
	makeCanvasViewUseObj() {

		let ucList = this._userCOp.getUserCustomList();
		let kariList = [];
		let canvasViewUseObj = {};

		for(let i=0, n=ucList.length; i<n; i++) {
			let cont = new PoolContents(ucList[i]);

			let categFact = this._dataHangar.getCategFactory( cont.categ );
			let booDup = categFact.getMakeDefBooArray( cont.bit1Arr, cont.bit2Arr, false);
			cont.booDupArray = booDup;

			//  predData 作成  copyAに プロパティを追加
			let booArr = categFact.getMakeResultBooArray( cont.bit1Arr, cont.bit2Arr, 0 );
			//  プロパティ名 'booArray' 設定
			cont.booArray = booArr;
			let booDef = categFact.getMakeDefBooArray(cont.bit1Arr, cont.bit2Arr, true);
			//  プロパティ名 'booDefArray' 設定
			cont.booDefArray = booDef;

			kariList.push(cont);
		};

		let arrayDup = [];
		let arrayDef = [];
		let arrayBoo = [];
		let booArrArray = [   arrayBoo, arrayDef, arrayDup   ];
		for(let i=0, n=kariList.length; i<n; i++) {
			let cont = kariList[i];
			booArrArray[0][i] = cont.booArray;
			booArrArray[1][i] = cont.booDefArray;
			booArrArray[2][i] = cont.booDupArray;	
		};

		let booArrArray2 = [];
		for(let i=0, n=booArrArray.length; i<n; i++) {
			let booArrInn = booArrArray[i][0];
			for(let j=1, m=booArrArray[i].length; j<m; j++) {
				booArrInn = this.makeCompositionBooArray( booArrInn, booArrArray[i][j]);
			};
			booArrArray2.push( booArrInn );
		};

		if(kariList.length===0) {
			booArrArray2 = this.makeFillBooArrArray();
		};

		let defCount = this.booArrayCount( booArrArray2[1] );
		let dupCount = this.booArrayCount( booArrArray2[2] );
		let predData = this._dataHangar.makePredictData( booArrArray2[0], defCount);

		canvasViewUseObj.booArray = booArrArray2[0];
		canvasViewUseObj.booDefArray = booArrArray2[1];
		canvasViewUseObj.booDupArray = booArrArray2[2];

		//  プロパティ名 'predData' 設定
		canvasViewUseObj.predData = predData;
		canvasViewUseObj.totalDefCt = defCount;
		canvasViewUseObj.totalDupCt = dupCount;
		
		return canvasViewUseObj;
	}
	makeCompositionBooArray( booArr1, booArr2) {

		let booArr = new Uint8Array( booArr1.length );
		//MyUtility.setFillArray(this._totalDefBooArray, 1);
		for(let i=0, n=booArr1.length; i<n; i++) {
			if(booArr1[i]===1 && booArr2[i]===1) {
				booArr[i] = 1;
			}else {
				booArr[i] = 0;
			};
		};
		return booArr;
	};
	makeFillBooArrArray() {

		let resultArr = [];
		let booArray = new Uint8Array(this._resultDataArr.length);
		MyUtility.setFillArray(booArray, 1);
		resultArr.push( booArray );

		let booDefArray = new Uint8Array(this._contPool.totalDefBooArray.length);
		MyUtility.setFillArray(booDefArray, 1);
		resultArr.push( booDefArray );

		let booDupArray = new Uint8Array(this._contPool.totalDupBooArray.length);
		MyUtility.setFillArray(booDupArray, 1);
		resultArr.push( booDupArray );
		return resultArr;
	};
	booArrayCount(arr) {
		let count = 0;
		for(let i=0, n=arr.length; i<n; i++) {
			if(arr[i]===1) {
				count++;
			};
		};
		return count;
	};



	//
	userCStrageSave() {
	
		let userCu = this._state['userCu'+this._or34] || {};

		console.log('now-categ  '+this._now_categ);

		userCu[this._now_categ] = this._userCOp.getCheckBox(this._now_categ).userCustomStateObj();

		this.setUserCustomToStorage(userCu);

		this.user_c_TableView();
	};
	user_c_TableView() {

		this._state = StorageOperator.getStorageData('session', 'state');

		let userCu = this._state['userCu'+this._or34] || null;

		let userCOp = new UserCustomOperator(this._or34, this._dataHangar.nb);
		userCOp.setUserCustomStateObj( userCu );

		let key = userCOp.checkBoxKey;
		for(let i=0; i<key.length; i++) {
			let checkBox = userCOp.getCheckBox( key[i] );
			let text;
			if(key[i]==='cho') {
				text = MyUtility.arrayToString( checkBox.getTrueNumerArray(), (array) => array[0] === 0 ?  '無' : '有' );
			}else if( key[i]==='rea' ){
				text = MyUtility.arrayToString( checkBox.getTrueNumerArray(), (array) => '除' );
			}else {
				text = MyUtility.arrayToString( checkBox.getTrueNumerArray() );
			};
			MyUtility.setElementText( key[i]+'-user', text );
		};

	};





    

    	//  ボタンPush
	funcPushS(val) {
		this._userCOp.pushS(val);
		this.pushSub();
	};
	funcPushJ(val) {
		this._userCOp.pushJ(val);
		this.pushSub();
	};

	funcPushF(val) {
		this._userCOp.pushF(val);
		this.pushSub();
	};


	funcPushC(val) {
		this._userCOp.pushC(val);
		this.pushSub();
	};
	funcPushR(val) {
		this._userCOp.pushR(val);
		this.pushSub();
	};
	//  チェックボックス リセット
	checkBoxRt(val) {

		this._userCOp.checkBoxRt(val);
		this.pushSub();
	};
	pushSub() {
		let ucList = this._userCOp.getUserCustomList();
		this._contPool.setUserCustomList( ucList );

		//
		//camvasView
		this._canvasViewObj.setPup3ObjDataDeploy(this.makeCanvasViewUseObj());
		this._canvasViewObj.paintAll();
		
		this._resultTableView();
	};

	//  各種状態 View
	_setAllBtStyle() {
		this._userCOp.setAllBtStyle();
		this._resultTableView();
	};





	//  addEvent

	_resultTableView() {

		//  userCustom
		let key = this._userCOp.checkBoxKey;
		for(let i=0; i<key.length; i++) {
			let checkBox = this._userCOp.getCheckBox( key[i] );
			let text;
			if(key[i]==='cho') {
				text = MyUtility.arrayToString( checkBox.getTrueNumerArray(), (array) => array[0] === 0 ?  '無' : '有' );
			}else if( key[i]==='rea' ){
				text = MyUtility.arrayToString( checkBox.getTrueNumerArray(), (array) => '除' );
			}else {
				text = MyUtility.arrayToString( checkBox.getTrueNumerArray() );
			}
			MyUtility.setElementText( key[i], text );
		};
		//  contPool
		 MyUtility.setElementText( 'nowBox', `${this._contPool.totalDupCount} / ${this._contPool.totalDupBooArray.length}` );
		 MyUtility.setElementText( 'nowStraight', `${this._contPool.totalPt} / ${this._contPool.totalDefBooArray.length}` );

    };
    

    //  現在の userCustom の状態を Storage に記入
	setUserCustomToStorage(ucObj) {

		//let ucObj = this._userCOp.getUserCustomStateObj();

		let boo = [true, true];
		try {
			boo = StorageOperator.storageSetProperty(  'userCu'+this._or34, ucObj );
		}catch(exeption) {
			alert('お使いのブラウザでは、本サイトは正常に動作しません');
		};

		return boo;

	};





	categoryChange() {

		let arr = this._category_str_arr;
		let arr_str = this._categ_text_arr;

		for(let i=0, n=arr.length; i<n; i++) {
			document.getElementById('view-'+arr[i]).style['display'] = 'none';
			document.getElementById('check-'+arr[i]).style['display'] = 'none';

			if(i===2) {
				if( this._userCOp.checkBoxMap.get('fuk').getTrueNumerArray().length>0 ) {
					this.checkBoxRt(i);
				};
			}else {
				this.checkBoxRt(i);
			};
		};
		
		for(let i=0, n=arr.length; i<n; i++) {
			if(this._now_categ===arr[i]) {

				let index = i<arr.length-1 ? i+1 : 0;

				document.getElementById('view-'+arr[index]).style['display'] = 'table-row';
				document.getElementById('check-'+arr[index]).style['display'] = 'table-row';
				document.getElementById('categBt').textContent = arr_str[index];

				this._now_categ = arr[index];
				break;
			};
		};


		this._categBtColorIndex = ++this._categBtColorIndex%this._categBtColorArray.length;
		MyUtility.setElementStyle( 'categBt', 'backgroundColor', this._categBtColorArray[this._categBtColorIndex] );

	};


};



//
//
	/* class canvasView */

class CanvasView {

	constructor(themeIndex) {
	
		this._canvas1 = document.getElementById( 'canvas1' );
		this._canvas2 = document.getElementById( 'canvas2' );
		this._canvas3 = document.getElementById( 'canvas3' );
	
		this.allEventAdd();
	
		this._PRED_SIZE = [];
		this._PRED_RANGE = [ 5, 10, 20, 50 ];
		this._VIEW_USE_PRED_SIZE = [ 3, 4, 5, 6, 9 ];
	
		this._VIEW_RANGE = [  480, 470, 460  ];
	
		this._canvasArrayOffsetDef = 480;
		this._canvasViewRange = 500-this._canvasArrayOffsetDef;
	
		this._canvasArrayOffset = this._canvasArrayOffsetDef;
	
		this._rightNodeState = 0;
	
	
			//  テーマ
		this._THEME_0 = { numb: 0,  white: 'white', back: 'rgba(92,168,239,1)', gradaB: [ 92,168,239 ],
									gradaItv: [ 32, 17, 3 ], back2: 'rgb(62, 148, 242)', graphBack: 'rgba(105, 188, 255, 0.85)',
									strokeLine: 'rgba(5, 25, 255, 0.8)', strokeGraphF: 'rgba(37, 53, 111, 0.95)',
									graphUp: 'rgba(50, 252, 90, 0.8)', graphDown: 'rgba(230, 210, 5, 0.8)',
									movingA_S: 'rgb(210, 85, 10)',  movingA_M: 'rgb( 255, 255, 255)',
									movingA_L: 'rgb(255,255,0)'  };
	
		this._THEME_1 = { numb: 1,  white: 'white', back: 'rgba(50,50,50,1)', gradaB: [ 50,50,50 ],
									gradaItv: [ 40, 40, 40 ], back2: 'rgb(25, 25, 25)', graphBack: 'rgba(70, 70, 70, 1)',
									strokeLine: 'rgba(10, 10, 10, 1)', strokeGraphF: 'rgba(5, 5, 5, 1)',
									graphUp: 'rgba(50, 252, 90, 0.8)', graphDown: 'rgba(230, 210, 5, 0.8)',
									movingA_S: 'rgb(10, 130, 240)',  movingA_M: 'rgb( 255, 255, 255)',
									movingA_L: 'rgb(230,230,0)'  };
	
		this._THEME_2 = { numb: 2,  white: 'rgb(30,30,30)', back: 'rgba(230,230,245,1)', gradaB: [ 240,240,255 ],
									gradaItv: [ -48, -48, -50 ], back2: 'rgb(215, 215, 235)', graphBack: 'rgba(180, 180, 200, 1)',
									strokeLine: 'rgba(10, 10, 10, 1)', strokeGraphF: 'rgba(145, 145, 205, 1)',
									graphUp: 'rgba(50, 252, 90, 0.8)', graphDown: 'rgba(230, 210, 5, 0.8)',
									movingA_S: 'rgb(10, 130, 240)',  movingA_M: 'rgb( 255, 255, 255)',
									movingA_L: 'rgb(255,255,0)'  };
	
		this._themeArray = [   this._THEME_0, this._THEME_1, this._THEME_2   ];
		this._THEME = this._themeArray[ themeIndex ];
		this._setThemeColor();
	
	};
	
	get canvasViewRange() {   return 500-this._canvasArrayOffsetDef;   }
	
	set canvasArrayOffsetDef(val) {
	
		this._canvasArrayOffsetDef = val;
		this._canvasArrayOffset = this._canvasArrayOffsetDef;
		this.paint( this._canvasArrayOffsetDef, 'canvas1' );
	}
	
	
	_setThemeColor() {
	
		this._styleWhite = this._THEME.white;
		this._fillStyleBack = this._THEME.back;
		this._gradationBase = this._THEME.gradaB;
		this._gradationItv = this._THEME.gradaItv;
	
		this._fillStyleBack2 = this._THEME.back2;
		this._fillStyleGraphBack = this._THEME.graphBack;
	
		this._strokeStyleLine = this._THEME.strokeLine;
	
		this._strokeStyleCenterGraphFrame = this._THEME.strokeGraphF;
		this._fillStyleCenterGraphUp = this._THEME.graphUp;
		this._fillStyleCenterGraphDown = this._THEME.graphDown;

		this._movingA_S = this._THEME.movingA_S;
		this._movingA_M = this._THEME.movingA_M;
		this._movingA_L = this._THEME.movingA_L;
	
	};
	
	
	
	
	setPup3ObjDataDeploy(pup3SelectObj) {
	
		this._pup3Obj = pup3SelectObj;
	
		this._booArray = this._pup3Obj.booArray;
	
		this._PRED_SIZE = [5, 10, 20, 50, 100, 200, 500, 1000, 2000, this._booArray.length];
	
		this._indexStart = this._booArray.length-500;
		this._booArr500 = this._booArray.slice(this._booArray.length-500);
		this._booArr500Itv5 = MyUtility.booArrayIntervalCount(this._booArr500, 5);
	
		this._totalCountArray = [ this._pup3Obj.totalDupCt, this._pup3Obj.booDupArray.length,
														this._pup3Obj.totalDefCt, this._pup3Obj.booDefArray.length ];
	
		this._percent = this._pup3Obj.predData.get('percent');
	
		this._thV = this._pup3Obj.predData.get('theoryVal');
		this._errThV = this._pup3Obj.predData.get('errThVal');
		this._resultCt = this._pup3Obj.predData.get('resultCt');
		this._thGap = this._pup3Obj.predData.get('thValCountGap');
	
		this._predSizeUse = [];
		this._thVUse = [];
		this._errThVUse = [];
		this._resultCtUse = [];
		this._thGapUse = [];
	
		for(let i=0, useSize=this._VIEW_USE_PRED_SIZE, n=useSize.length; i<n; i++) {
			this._predSizeUse.push( this._PRED_SIZE[ useSize[i] ] );
			this._thVUse.push( Math.round( this._thV[ useSize[i] ] ) );
			this._errThVUse.push( this._errThV[ useSize[i] ].toFixed(1) );
			this._resultCtUse.push( this._resultCt[ useSize[i] ] );
			this._thGapUse.push( this._thGap[ useSize[i] ].toFixed(1) );
		};
	
		this._itvMap = this._pup3Obj.predData.get('intervalMap');
	
		this._itvMap5 = this._itvMap.get(5);
		this._itvMap10 = this._itvMap.get(10);
		this._itvMap20 = this._itvMap.get(20);
		this._itvMap50 = this._itvMap.get(50);
	
	};
	
	
	paintAll() {
	
		this.paint( this._canvasArrayOffsetDef, 'canvas1' );
		this.paint2();
		this.paint3( this._rightNodeState );
	};
	
	
	
	allEventAdd() {
	
		let itvVal = [ 1, 10, -10, -1 ];
		let start = 'mousedown',   end = 'mouseup';
	
		if ("ontouchstart" in window) {
			start = 'touchstart';      end = 'touchend';
			document.addEventListener("touchcancel", this._canvasTimeE(), false);
		};
		for(let i=0, n=itvVal.length; i<n; i++) {
			MyUtility.setElementEvent( 'opre_bt'+itvVal[i], start, () => this._canvasTimeS(itvVal[i]), false );
			MyUtility.setElementEvent( 'opre_bt'+itvVal[i], end, () => this._canvasTimeE(), false );
		};
	
	
		MyUtility.setElementEvent( 'opre_btRt', 'click', () => this._cvReset(), false );
	
		this._canvas1.addEventListener("wheel", (e) => this.mouseWheelProcess(e) );
	
		MyUtility.setElementEvent( 'change', 'click', () => this.canvasRtChange(), false );
	
	};
	
	
	_windowToCanvas(canvas, x, y) {
		var bbox = canvas.getBoundingClientRect();
		return {  x:  (x - bbox.left) * (canvas.width / bbox.width),
						   y:  (y - bbox.top) * (canvas.height / bbox.height)    };
	};
	
	
	mouseWheelProcess(e) {
		var loc = this._windowToCanvas( this._canvas1, e.clientX, e.clientY);
		if(loc.x > 0 && loc.x <130) {
	
			e.preventDefault();
			if(e.deltaY>0) {
				this._canvasF(2);
			}else {
				this._canvasF(-2);
			};
		};
	};
	
	
	
	
	
	//  canvas ボタン
	
	_canvasTimeS(val) {
	
		let sig = Math.sign( val );
		let itv = Math.abs( 200/val );
		this._canvasF( sig );
		this._timer = window.setInterval( () => this._canvasF( sig ), itv );
	};
	
	_canvasTimeE() {     window.clearInterval(this._timer);     };
	
	
	
	_canvasF(val) {
		let zz = this._canvasFSub( this._canvasArrayOffset, val);
		this.paint( zz, 'canvas1' );
	};
	
	_canvasFSub( cvArrOffset, val ) {
	
		let zz = ( cvArrOffset + val );
		if(zz<0) {   zz = 0;   };
		if( zz > this._canvasArrayOffsetDef ) {   zz = this._canvasArrayOffsetDef;   };
		this._canvasArrayOffset = zz;
	
		return zz;
	};
	
	
	
	
	//  this._canvasArrayOffset  リセット
	_cvReset() {
	
		this._canvasArrayOffset = this._canvasArrayOffsetDef;
	
		this.paint( this._canvasArrayOffset, 'canvas1' );
	};
	
	
	_zzChangeBtColor( zz ) {
	
		let def = this._canvasArrayOffsetDef;
		if( zz === def ) {
			this._zzChangeBtColorSub(  'rgba(0,255,130,0.4)', '#00ff7f', '#ccccef', '#ffffff' );
		}else if(zz===0) {
			this._zzChangeBtColorSub( '#00ff7f', 'rgba(0,255,130,0.4)', '#ffffff', '#ccccef' );
		}else if( ( (def-3)<=zz && zz<=(def-1) ) ||  (1<=zz && zz<=3) ){
			this._zzChangeBtColorSub( '#00ff7f', '#00ff7f', '#ffffff', '#ffffff' );
		};
	};
	_zzChangeBtColorSub( backColor1, backColor2, color1, color2 ) {
		let itvVal = [ 1, 10, -10, -1 ];
		let backColor = [ backColor1, backColor1, backColor2, backColor2 ];
		let color = [ color1, color1, color2, color2 ];
		let btStyle = [];
		for(let i=0; i<4; i++) {
			document.getElementById( 'opre_bt'+itvVal[i] ).style.background = backColor[i];
			document.getElementById( 'opre_bt'+itvVal[i] ).style.color = color[i];
		};
	};
	
	
	
	//  テーマ変更
	themeChange() {
		for(let i=0, n=this._themeArray.length; i<n; i++) {
			if( this._THEME.numb === i ) {
				this._THEME = this._themeArray[(i+1)%n];
				break;
			};
		};
		this._setThemeColor();
		this.paintAll();
	};
	
	canvasViewRangeChange() {
	
		for(let i=0, n=this._VIEW_RANGE.length; i<n; i++) {
			if(this._VIEW_RANGE[i]===this._canvasArrayOffsetDef) {
				this.canvasArrayOffsetDef = this._VIEW_RANGE[(i+1)%n];
				break;
			};
		};
	};
	
	
	
	
	//   paint
	
	paint(zz, cv) {
	
		this._zzChangeBtColor( zz );
	
		let canvas = document.getElementById( cv );
	
		if (canvas.getContext) {
	
			let context = canvas.getContext('2d');
	
			//  画面クリア
			context.fillStyle = this._fillStyleBack;
			context.fillRect(0, 0, 280, 450);
	
			//  枠
			context.strokeStyle = this._styleWhite;
			context.strokeRect(5, 5, 130, 400);
	
			context.strokeRect(182, 200, 96, 205);
	
	
			//テキスト描画のスタイルを指定
			context.fillStyle = this._styleWhite;
			context.font = "13px 'Meiryo'";
			context.textAlign = "left";
			context.textBaseline = "top";
	
			//  オフセットブロック size
			let offsetBkSize = this.canvasViewRange/500*400;
			//  左オフセットブロック
			context.fillRect(120, 6+zz*0.8, 7, offsetBkSize);
			//  右オフセットブロック
			context.fillRect(165, 5+Math.floor(zz/5)*4, 7, offsetBkSize);
			//
			let arr = this._booArr500;
			let indStart = this._indexStart;
	
			this._leftViewPaint(context, zz, arr, indStart);
	
	
			context.font = "13px 'Meiryo'";
			context.fillText((indStart+501)+"           ?", 10, 415, 165);
			context.fillRect(70, 417, 15, 15);
	
			//
			context.font = "14px 'Meiryo'";
	
			context.fillRect(190, 221, 15, 15);
			context.fillText("率", 216, 219, 20);
	
			context.fillText( this._percent+"%", 210, 240, 60);
	
			context.fillText( "残数" , 190, 270, 40);
			context.fillText( "B", 200, 300, 40);     context.fillText( "S", 200, 350, 40);
	
			context.textAlign = "center";
	
			for(let i=0, n=this._totalCountArray.length; i<n; i++) {
				let bar = 0.5;
				if(i>1) {  bar = 10.5;  }
				context.fillText( this._totalCountArray[i], 243, 290+(i*21)+bar, 50);
			};
	
			//
			context.beginPath();
			context.moveTo(221, 310.5);
			context.lineTo(265, 310.5);
	
			context.moveTo(221, 362);
			context.lineTo(265, 361);
			context.stroke();
			context.closePath();
			//
	
	
	
			let arrayMeta = this._booArr500Itv5;
			for(let i=0; i<arrayMeta.length; i++) {
				let ct = arrayMeta[i];
	
				this._paintRect(ct, context);
	
				context.fillRect(145, 5+i*4, 15, 4);
			};
	
			for(let i=0; i<6; i++) {
	
				this._paintRect(i, context);
	
				context.fillRect(180, 19.5+i*20, 15, 10);
	
				context.fillStyle = this._styleWhite;
				context.fillText(i, 207, 14+i*20, 16);
			};
			context.strokeRect(179.5, 19, 16, 11);
				//
		};
	};
	
	_leftViewPaint( context, zz, arr, indStart ) {
	
		let range = this.canvasViewRange;
		let boxRange = 400/range;
		let big = boxRange*0.75;
		let sml = boxRange*0.15;
		let bigG = (boxRange-big)/2;
		let smlG = (boxRange-sml)/2;
	
		let rangeX = boxRange/2;
	
		let fontSizeSub = range/50;
		let fontSize = Math.floor(boxRange*(0.25+fontSizeSub));
	
		context.font = fontSize+"px 'Meiryo'";
	
		for(let i=0; i<range; i++) {
	
			context.fillText((i+zz+indStart+1), 10, 4.5+i*boxRange, 55);
	
			if(arr[i+zz]==0) {
				context.fillRect(78+smlG-rangeX, 5+smlG+i*boxRange, sml, sml);
			}else {
				context.fillRect(78+bigG-rangeX, 5+bigG+i*boxRange, big, big);
			};
		};
	};
	
	
	_paintRect(ct, context) {
	
		let rgb = [];
		for(let i=0; i<3; i++) {
			rgb.push( this._gradationBase[i]+(this._gradationItv[i]*ct) );
		};
		context.fillStyle = 'rgba('+rgb[0]+','+rgb[1]+','+rgb[2]+',1)';
	};
	
	
	
	paint2() {
	
		var zzCt = new Array();
		for(var i=0, n=this._predSizeUse.length; i<n; i++) {
			zzCt[i] = this._resultCtUse[i] / this._predSizeUse[i]*180;
		};
	
		var canvas = this._canvas2;
		if (canvas.getContext) {
	
			var context = canvas.getContext('2d');
	
			//  画面クリア
			context.fillStyle =  this._fillStyleBack;
			context.fillRect(0, 0, 280, 500);
	
			context.fillStyle = this._fillStyleBack2;
			context.fillRect(50, 300, 225, 40);
			context.fillRect(50, 420, 225, 40);
	
			context.fillStyle = this._fillStyleGraphBack;
			for(var i=0; i<zzCt.length; i++) {
				context.fillRect(60+i*45, 60, 25, 180);
			};
	
			//
			context.beginPath();
			context.strokeStyle = this._strokeStyleLine;
			var ofs = 240-( 180*this._percent/100 );
			context.moveTo(50, ofs);
			context.lineTo(275, ofs);
			context.stroke();
			context.closePath();
			//
	
			context.fillStyle = this._styleWhite;
			context.font = "13px 'Meiryo'";
			context.textAlign = "left";
			context.textBaseline = "top";
	
			for(var i=0; i<zzCt.length; i++) {
				context.fillRect(60+i*45, 60+(180-zzCt[i]), 25, zzCt[i]);
			};
	
			var ofsL = 0;
			for(var i=0, n=this._thVUse.length; i<n; i++) {
				if(i<2) {   ofsL = 3.5;   }else {   ofsL = 0;}
				context.fillText( this._thVUse[i], 60+ofsL+i*45, 10, 30);
			};
			context.fillText( "理値", 10, 10, 40);
	
			for(var i=0, n=this._resultCtUse.length; i<n; i++) {
				if(i<2) {   ofsL = 3.5;   }else {   ofsL = 0;}
				context.fillText( this._resultCtUse[i], 60+ofsL+i*45, 30, 30);
			};
			context.fillText( "実値", 10, 30, 40);
	
			context.fillText( this._percent+"%", 5, ofs-10, 40);
	
			for(var i=0, n=this._predSizeUse.length; i<n; i++) {
				if(i<1) {   ofsL = 3.5;   }else {   ofsL = 0;}
				context.fillText( this._predSizeUse[i], 60+ofsL+i*45, 240, 30);
			};
			context.fillText( "レンジ", 7, 240, 40);
	
			//
			for(var i=0; i<5; i++) {
				context.fillRect(60+i*45, 380, 25, 80);
			};
	
			//
			context.beginPath();
			context.strokeStyle = this._strokeStyleLine;
			context.moveTo(50, 380);
			context.lineTo(275, 380);
			context.stroke();
			context.closePath();
	
			context.fillText( "理値", 10, 372, 40 );
	
			context.fillText( "理差+", 8, 332, 40 );
			context.fillText( "理差 -", 8, 412, 40 );
			//
	
	
			context.strokeStyle = this._strokeStyleCenterGraphFrame;
	
			var errCt = new Array();
			var errCtOver = new Array();
			for(var i=0, n=this._errThVUse.length; i<n; i++) {
	
				errCt[i] = this._thGapUse[i] / this._errThVUse[i]*-40;
				if(errCt[i]>80) {
					errCt[i] = 80;          errCtOver[i] = 1;
				}else if(errCt[i]<-80) {
					errCt[i] = -80;          errCtOver[i] = -1;
				}else {
					errCtOver[i] = 0;
				};
			};
			for(var i=0; i<errCt.length; i++) {
	
				if(errCt[i]<0) {
					context.fillStyle = this._fillStyleCenterGraphUp;
					context.fillRect(60+i*45, 380+errCt[i], 25, errCt[i]*-1);
	
					context.strokeRect(59.5+i*45, 379.5+errCt[i], 26, 81-errCt[i]);
	
				}else if(errCt[i]>0) {
					context.fillStyle = this._fillStyleCenterGraphDown;
					context.fillRect(60+i*45, 380, 25, errCt[i]);
	
					context.strokeRect(59.5+i*45, 379.5+errCt[i], 26, 81-errCt[i]);
				}else {
					context.strokeRect(59.5+i*45, 379.5, 26, 81);
				};
			};
	
	
			context.fillStyle = this._strokeStyleLine;
			for(var i=0, n=errCtOver.length; i<n; i++) {
				if(errCtOver[i]===1) {
					context.fillText( 'over', 62+ofsL+i*45, 438, 22);
				}else if(errCtOver[i]===-1) {
					context.fillText( 'over', 62+ofsL+i*45, 300, 22);
				};
			};
	
	
			context.strokeStyle = this._styleWhite;
			context.strokeRect(50, 300, 225, 160);
	
			context.fillStyle = this._styleWhite;
	
			for(var i=0, n=this._thGapUse.length; i<n; i++) {
				var st = String(this._thGapUse[i]);
				ofsL = 9-(st.length-1)*2.5;
				context.fillText( this._thGapUse[i], 60+ofsL+i*45, 280, 30);
			};
			context.fillText( "差", 18, 280, 40);
	
	
			for(var i=0, n=this._errThVUse.length; i<n; i++) {
				var st = String( this._errThVUse[i] );
				ofsL = 9-(st.length-1)*2.5;
				context.fillText( this._errThVUse[i], 60+ofsL+i*45, 465, 30);
			};
			context.fillText( "理差", 10, 463, 40);
	
		};
	};
	
	
	paint3(val) {
	
		var zz50Ct = new Array();
		var zz20Ct = new Array();
		var zz10Ct = new Array();
		var zz5Ct = new Array();
	
		for(var i=0, n=this._itvMap50.length; i<n; i++) {
			zz50Ct[i] = this._itvMap50[i]/50*120;
			zz20Ct[i] = this._itvMap20[i]/20*120;
			zz10Ct[i] = this._itvMap10[i]/10*120;
			zz5Ct[i] = this._itvMap5[i]/5*120;
		};
	
		let indStart = this._indexStart;
	
		var range50Top = indStart;
		var range20Top = indStart+500-200;
		var range10Top = indStart+500-100;
		var range5Top = indStart+500-50;
	
	
	
		var canvas = document.getElementById( 'canvas3' );
		if (canvas.getContext) {
	
			var context = canvas.getContext('2d');
	
			//  画面クリア
			context.fillStyle =  this._fillStyleBack;
			context.fillRect(0, 0, 280, 450);
	
			if(val==0) {
				this.paint3Sub(context, this._itvMap50, this._thV[3].toFixed(1), zz50Ct, 5 , range50Top, 50);
	
				this.paint3Sub(context, this._itvMap20, this._thV[2].toFixed(1), zz20Ct, 235, range20Top, 20 );
			}else if(val==1) {
				this.paint3Sub(context, this._itvMap10, this._thV[1].toFixed(1), zz10Ct, 5 , range10Top, 10);
	
				this.paint3Sub(context, this._itvMap5, this._thV[0].toFixed(1), zz5Ct, 235, range5Top, 5 );
			}else {

				this.paint3MovingAverage( context, val );
			};
		};
	};
	
	
	paint3Sub( context ,zz5020Arr, zz52, zzCt, ofsY, rangeTop, range ) {
	
		context.fillStyle = this._fillStyleGraphBack;
		for(var i=0; i<10; i++) {
			context.fillRect(150, 20+i*20+ofsY, 120, 13);
		};
	
		context.strokeStyle = this._styleWhite;
		context.strokeRect(20, 60+ofsY, 90, 110);
	
		context.fillStyle = this._styleWhite;
		context.textAlign = "center";
		context.textBaseline = "top";
	
		context.font = "16px 'Meiryo'";
	
		context.fillText( "間隔. "+range, 65, 75+ofsY, 95);
	
		context.font = "15px 'Meiryo'";
	
		context.fillText( "理論値", 65, 115+ofsY, 60);
		context.fillText( zz52, 65, 137+ofsY, 60);
	
		for(var i=0; i<10; i++) {
			context.fillText( zz5020Arr[9-i], 135, 18+i*20+ofsY, 60);
		};
	
		context.textAlign = "left";
		context.fillText( '~ '+(rangeTop+1)+'回', 48, 18+ofsY, 62);
		context.fillText( rangeTop+range*10+'回 ~', 48, 197+ofsY, 62);
	
	
		//
		context.beginPath();
		context.strokeStyle = this._fillStyleGraphBack;
		context.moveTo(27, 233);
		context.lineTo(280, 233);
		context.stroke();
		//context.closePath();
		//
		context.beginPath();
		context.strokeStyle = this._strokeStyleLine;
		var ofs = 150+( 120 * this._percent / 100 );
		context.moveTo(ofs, 15+ofsY);
		context.lineTo(ofs, 218+ofsY);
		context.stroke();
		//context.closePath();
		//
		for(var i=0; i<10; i++) {
			context.fillRect(150, 20+i*20+ofsY, zzCt[9-i], 13);
		};
	
		context.textAlign = "center";
		context.font = "14px 'Meiryo'";
		context.fillText(range, 266, 2+ofsY, 30);
		context.fillText( zz52, ofs, 2+ofsY, 40);
	
	};

	paint3MovingAverage( context, type ) {

		let arrayS = type==2 ? this.makeWeightedMovingAverage(25, 200, this._booArray) : this.makeExponentialMovingAverage(25, 200, this._booArray);
		let arrayM = type==2 ? this.makeWeightedMovingAverage(100, 200, this._booArray) : this.makeExponentialMovingAverage(100, 200, this._booArray);
		let arrayL = type==2 ? this.makeWeightedMovingAverage(300, 200, this._booArray) : this.makeExponentialMovingAverage(300, 200, this._booArray);

		let maText = type==2 ? "加重" : "独自";
		//
		let ofx = 65;
		let ofy = 30
		let width = 210;
		let height = 400;
		context.fillStyle = this._fillStyleGraphBack;
		context.fillRect(ofx, ofy, width, height);
		context.strokeStyle = this._styleWhite;
		context.strokeRect( ofx, ofy, width, height);

		let per = (this._percent/100);
		let perText = this._percent;

		//  text
		context.fillStyle = this._styleWhite;
		context.textAlign = "left";
		context.font = "13px 'Meiryo'";

		context.fillText( maText, 5, 5, 65);
		context.fillText( "S-25", 65, 435, 30);
		context.fillText( "M-100", 140, 435, 30);
		context.fillText( "L-300", 210, 435, 30);

		context.font = "13px 'Meiryo'";
		context.fillText( 0, 63, 5, 20);
		context.fillText( perText, ofx+width*per-20, 5, 50);
		context.fillText( 100, 255, 5, 25);
		let index = [ -200, -150, -100, -50, 0 ];
		context.textAlign = "center";
		for(let i=0; i<5; i++) {
			let y = Math.round(ofy+height/4*i)-10;
			context.fillText( index[i], 45, y, 40);
		};

		//
		context.lineWidth = 0.5;

		context.strokeStyle = this._strokeStyleLine;
		context.beginPath();
		context.moveTo( Math.round(ofx+width*per), ofy);
		context.lineTo( Math.round(ofx+width*per), height+ofy);
		context.stroke();
		context.strokeStyle = this._styleWhite;
		for(let i=1; i<4; i++) {
			context.beginPath();
			let y = Math.round(ofy+height/4*i);
			context.moveTo( ofx, y);
			context.lineTo( ofx+width, y);
			context.stroke();	
		};


		//
		context.lineJoin = "round";
		context.lineWidth = 1.3;

		context.strokeStyle = this._movingA_L;
		context.beginPath();
		context.moveTo(  ofx+arrayL[0]*width, ofy );
		for(let i=1, n=arrayL.length; i<n; i++) {
			context.lineTo( ofx+arrayL[i]*width, ofy+i*2);
		};
		context.stroke();
		context.beginPath();
		context.moveTo( 245+5, 445);
		context.lineTo( 245+20, 445);
		context.stroke();	


		context.strokeStyle = this._movingA_M;
		context.beginPath();
		context.moveTo(  ofx+arrayM[0]*width, ofy );
		for(let i=1, n=arrayM.length; i<n; i++) {
			context.lineTo( ofx+arrayM[i]*width, ofy+i*2);
		};
		context.stroke();
		context.beginPath();
		context.moveTo( 170+5, 445);
		context.lineTo( 170+20, 445);
		context.stroke();	

		context.strokeStyle = this._movingA_S;
		context.beginPath();
		context.moveTo(  ofx+arrayS[0]*width, ofy );
		for(let i=1, n=arrayS.length; i<n; i++) {
			context.lineTo( ofx+arrayS[i]*width, ofy+i*2);
		};
		context.stroke();
		context.beginPath();
		context.moveTo( 95+5, 445);
		context.lineTo( 95+20, 445);
		context.stroke();	

	};
	makeWeightedMovingAverage(range, rate, target) {

		let weight = (range+1)*(range/2.0);

		let resultArr = this.makeArray(rate, 0.0);

		for(let i=rate; i>0; i--) {
			let rateIndex = target.length-i;
			for(let j=1; j<=range; j++) {
				if(target[ rateIndex-( range-j ) ]) {  resultArr[rate-i] += j;  }
			};
			resultArr[rate-i] = resultArr[rate-i]/weight;
		};
		return resultArr;
	};
	makeExponentialMovingAverage(range, rate, target) {

		let resultArr = this.makeArray(rate, 0.0);

		let exponentialCount = 0.0;
		for(let i=1; i<=range; i++) {
			exponentialCount += Math.sqrt(i);
		};
		for(let i=rate; i>0; i--) {
			let rateIndex = target.length-i;
			for(var j=1; j<=range; j++) {
				if(target[ rateIndex-( range-j ) ]) {  resultArr[rate-i] += Math.sqrt(j);  }
			};
			resultArr[rate-i] = resultArr[rate-i]/exponentialCount;
		};
		return resultArr;
	};
	makeArray(size, fill) {
		let array = [];
		for(let i=0; i<size; i++) {   array.push(fill);   };
		return array;
	};
	

	//
	canvasRtChange() {
	
		var val = this._rightNodeState;
	
		val = ++val%4;

		this._rightNodeState = val;
	
		this.paint3(val);
	};
	
	
	
};
	
	
	
